import React from "react";
import { Grid, Typography } from "@mui/material";
import Journey2021 from "../../svgComponents/Journey2021";
import Journey2020 from "../../svgComponents/Journey2020";
import Journey2022 from "../../svgComponents/Journey2022";
import Journey2023 from "../../svgComponents/Journey2023";
import backSmoke from "../../assets/backSmokeMobile.svg";

const JourneyMobile = (props) => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      mt={{ xs: -10, md: -15 }}
      mb={5}
      sx={{ display: props?.display }}
    >
      <Typography variant="h2" mb={5}>
        {props.title}
      </Typography>
      <Grid
        container
        item
        xs={12}
        flexDirection="column"
        alignItems="center"
        rowSpacing={{ xs: 3, sm: 6 }}
        sx={{
          background: `transparent url(${backSmoke}) no-repeat top -110vw center`,
          backgroundSize: { xs: "130vw" },
        }}
      >
        <Grid item>
          <Journey2020 sx={{ fontSize: { xs: "85vw" }, height: "100%" }} />
        </Grid>
        <Grid item>
          <Journey2021 sx={{ fontSize: { xs: "85vw" }, height: "100%" }} />
        </Grid>
        <Grid item>
          <Journey2022
            sx={{
              fontSize: { xs: "85vw" },
              height: "100%",
              transform: "rotate(2deg)",
            }}
          />
        </Grid>
        <Grid item>
          <Journey2023
            sx={{
              fontSize: { xs: "85vw" },
              height: "100%",
              marginLeft: 2,
              transform: "rotate(-2deg)",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default JourneyMobile;
